import { render, staticRenderFns } from "./CertificationEscalations.vue?vue&type=template&id=136b71bb&scoped=true&"
import script from "./CertificationEscalations.vue?vue&type=script&lang=js&"
export * from "./CertificationEscalations.vue?vue&type=script&lang=js&"
import style0 from "./CertificationEscalations.vue?vue&type=style&index=0&id=136b71bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136b71bb",
  null
  
)

export default component.exports